import styled from 'styled-components';

export const ImgStyle = styled.img`
	max-height: 25px;
	max-width: 75px;
	width: 75px;
	height:25px;
	object-fit: cover;
	
`;